/**
 * FAQ Accordion
 * Handles expanding/collapsing FAQ items
 */

document.addEventListener('DOMContentLoaded', function () {

  const faqButtons = document.querySelectorAll('.faq-question');

  faqButtons.forEach(button => {
    button.addEventListener('click', function () {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const answerId = this.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);
      const currentItem = this.closest('.faq-item');

      if (isExpanded) {
        // Close this item
        this.setAttribute('aria-expanded', 'false');
        answer.hidden = true;
        currentItem.classList.remove('is-open');
      } else {
        // Close any other open FAQ items on the page first
        document.querySelectorAll('.faq-question[aria-expanded="true"]').forEach(otherButton => {
          if (otherButton !== this) {
            otherButton.setAttribute('aria-expanded', 'false');
            const otherAnswerId = otherButton.getAttribute('aria-controls');
            const otherAnswer = document.getElementById(otherAnswerId);
            if (otherAnswer) {
              otherAnswer.hidden = true;
            }
            const otherItem = otherButton.closest('.faq-item');
            if (otherItem) {
              otherItem.classList.remove('is-open');
            }
          }
        });

        // Open this item
        this.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
        currentItem.classList.add('is-open');
      }
    });
  });

});
